type IDataType = "string" | "number" | "boolean" | "object" | "array";

export const safeParse = (
  type: IDataType,
  data: any,
  defaultValue: any = null
): any => {
  if (type === "array") {
    if (data && Array.isArray(data as any) && data.length) {
      return data;
    }
    return defaultValue || [];
  }

  // Force transform NaN to number
  if (type === "number") {
    data = isNaN(data) ? null : data;
  }

  if (data === null || typeof data !== type) {
    switch (type) {
      case "string":
        return defaultValue || "";
      case "number":
        return defaultValue || 0;
      case "boolean":
        return defaultValue || false;
      case "object":
        return defaultValue || {};
      default:
        return defaultValue || "";
    }
  }
  return data;
};
